module.exports = __webpack_public_path__ + "3f8efd1031d75d9be3e2ca123ebde24e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/leaning-t-owl-er-of-pisa-empty.png
// module id = 312
// module chunks = 0